/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import TSVersicherungsbeitragDTO from './TSVersicherungsbeitragDTO';

export default class TSVersicherungsbeitraegeSearchresultDTO {

    private _versicherungsbeitragDTOs: Array<TSVersicherungsbeitragDTO> = [];
    private _totalResultSize: number = 0;

    public get versicherungsbeitragDTOs(): Array<TSVersicherungsbeitragDTO> {
        return this._versicherungsbeitragDTOs;
    }

    public set versicherungsbeitragDTOs(value: Array<TSVersicherungsbeitragDTO>) {
        this._versicherungsbeitragDTOs = value;
    }

    get totalResultSize(): number {
        return this._totalResultSize;
    }

    set totalResultSize(value: number) {
        this._totalResultSize = value;
    }

    public parseSchadenfallDTOs(data: any): TSVersicherungsbeitragDTO[] {
        let pendenzen: TSVersicherungsbeitragDTO[] = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                pendenzen[i] = new TSVersicherungsbeitragDTO().deserialize(data[i]);
            }
        } else {
            pendenzen[0] = new TSVersicherungsbeitragDTO().deserialize(data);
        }
        return pendenzen;
    }

    deserialize(restObject: any): TSVersicherungsbeitraegeSearchresultDTO {

        this.versicherungsbeitragDTOs = this.parseSchadenfallDTOs(restObject.versicherungsbeitragDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSVersicherungsbeitraegeSearchresultDTO.ts